import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import { UserType } from "./api/authService";

import ClientMainPage from "./Pages/Client/MainPage";
import LandingPage from "./Pages/LandingPage";

import AdminLogin from "./Pages/Admin/Login";
import AdminLayout from "./Pages/Admin/AdminLayout";
import Dashboard from "./Pages/Admin/Dashboard";
import Users from "./Pages/Admin/Users";
import AccountAccess from "./Pages/Admin/AccountAccess";
import ClientWarnings from "./Pages/Admin/ClientWarnings";
import WholesaleClients from "./Pages/Admin/WholesaleClients";
import Stores from "./Pages/Admin/Stores";
import PartnerRequests from "./Pages/Admin/PartnerRequests";
import Orders from "./Pages/Admin/Orders";
import OrderDetail from "./Pages/Admin/OrderDetail";
import DeleteOrders from "./Pages/Admin/DeleteOrders";
import Delivery from "./Pages/Admin/Delivery";
import DeliveryCompanies from "./Pages/Admin/DeliveryCompanies";
import Categories from "./Pages/Admin/Categories";
import DeliveryPricing from "./Pages/Admin/DeliveryPricing";
import Cities from "./Pages/Admin/Cities";
import Advertisements from "./Pages/Admin/Advertisements";
import FeesSubscriptions from "./Pages/Admin/FeesSubscriptions";
import AdminDeliveryCompanyStoreFees from "./Pages/Admin/DeliveryCompanyStoreFees";
import Settings from "./Pages/Admin/Settings";
import Chats from "./Pages/Admin/Chats";

import BusinessOwnerLogin from "./Pages/BusinessOwner/Login";
import BusinessOwnerMainPage from "./Pages/BusinessOwner/MainPage";

import DeliveryLogin from "./Pages/Delivery/Login";
import DeliveryMainPage from "./Pages/Delivery/MainPage";

import DeliveryCompanyLogin from "./Pages/DelivryCompany/Login";
import DeliveryCompanyLayout from "./Pages/DelivryCompany/DeliveryCompanyLayout";
import DeliveryCompanyDashboard from "./Pages/DelivryCompany/Dashboard";
import DeliveryCompanyDrivers from "./Pages/DelivryCompany/Drivers";
import DeliveryCompanyOrders from "./Pages/DelivryCompany/Orders";
import DeliveryCompanyDriverAccess from "./Pages/DelivryCompany/DriverAccess";
import DeliveryCompanyFees from "./Pages/DelivryCompany/Fees";
import DeliveryCompanyStoreFees from "./Pages/DelivryCompany/StoreFees";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClientMainPage />} />
          <Route path="/join" element={<LandingPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredUserType={UserType.Admin} loginPath="/admin/login">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="account-access" element={<AccountAccess />} />
            <Route path="client-warnings" element={<ClientWarnings />} />
            <Route path="wholesale-clients" element={<WholesaleClients />} />
            <Route path="stores" element={<Stores />} />
            <Route path="partner-requests" element={<PartnerRequests />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="delete-orders" element={<DeleteOrders />} />
            <Route path="delivery" element={<Delivery />} />
            <Route path="delivery-companies" element={<DeliveryCompanies />} />
            <Route path="delivery-companies/store-fees" element={<AdminDeliveryCompanyStoreFees />} />
            <Route path="categories" element={<Categories />} />
            <Route path="delivery-pricing" element={<DeliveryPricing />} />
            <Route path="cities" element={<Cities />} />
            <Route path="advertisements" element={<Advertisements />} />
            <Route path="fees-subscriptions" element={<FeesSubscriptions />} />
            <Route path="chats" element={<Chats />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="/business/login" element={<BusinessOwnerLogin />} />
          <Route
            path="/business"
            element={
              <ProtectedRoute requiredUserType={UserType.BusinessOwner} loginPath="/business/login">
                <BusinessOwnerMainPage />
              </ProtectedRoute>
            }
          />

          <Route path="/delivery/login" element={<DeliveryLogin />} />
          <Route
            path="/delivery"
            element={
              <ProtectedRoute requiredUserType={UserType.Delivery} loginPath="/delivery/login">
                <DeliveryMainPage />
              </ProtectedRoute>
            }
          />

          <Route path="/delivry-company/login" element={<DeliveryCompanyLogin />} />
          <Route
            path="/delivry-company"
            element={
              <ProtectedRoute requiredUserType={UserType.DeliveryCompany} loginPath="/delivry-company/login">
                <DeliveryCompanyLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DeliveryCompanyDashboard />} />
            <Route path="drivers" element={<DeliveryCompanyDrivers />} />
            <Route path="orders" element={<DeliveryCompanyOrders />} />
            <Route path="driver-access" element={<DeliveryCompanyDriverAccess />} />
            <Route path="fees" element={<DeliveryCompanyFees />} />
            <Route path="store-fees" element={<DeliveryCompanyStoreFees />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
